module.exports = __webpack_public_path__ + "img/Dagger_dagger.762f44d0.png";